<template>
<div>
   <br>
 <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
<div>
  <v-card
    class="mx-auto"

  >

  <v-card height="140" color="primary" >

      <v-row>
          <v-col md="4">

                <img src="../../assets/usuario.png">

          </v-col>
          <v-col style="margin-top:20px;margin-left:70px;font-size:30px;" md="6"><h3 style="color:white;">Mudança de senha</h3></v-col>
      </v-row>

  </v-card>
        <v-card>
    <v-tabs vertical>

      <v-tab>
        <v-icon left>mdi-lock</v-icon>
           Editar Dados
      </v-tab>

       <v-tab-item>
        <v-card flat>
           <br>
           <div style="background-color:#DEE2E2;text-align:center" >Dados de usuário</div>
          <v-card-text>
            <v-row>
                 <v-col sm="12" md="6">Username:<strong>{{(usuario.length)?usuario[0].username:''}}</strong></v-col>
                <v-col sm="12" md="6">Ultimo vez Activo:<strong>{{(usuario.length)?usuario[0].data_user:''}}</strong></v-col>
             </v-row>
              <v-row>
                 <v-col sm="12" md="6">Role:<strong>{{role}}</strong></v-col>
             </v-row>
          </v-card-text>
          <v-card-action>
            <v-row>
              <v-col col="4"><v-btn color="blue" style="color:white" @click="mudarSenha()" ><v-icon>lock</v-icon>Mudar Senha</v-btn></v-col>
            </v-row>
          </v-card-action>

        </v-card>
      </v-tab-item>
      <v-tab-item>

        <v-card flat>
            <br>
           <div style="background-color:#DEE2E2;text-align:center;color:blue;" >Informações Pessoais</div>

          <v-card-text>
             <v-row>
                 <v-col md="4"><strong>Nome:</strong></v-col>
                <v-col md="8"><strong>{{loggedUserName}}</strong></v-col>
             </v-row>
              <v-row>
                 <v-col md="4"><strong>Data de Nascimento:</strong></v-col>
                <v-col md="8"><span v-if="getRole !== 'ROLE_EST'">Indisponível</span><span v-if="getRole === 'ROLE_EST'">{{getIdPessoa}}</span></v-col>
             </v-row>
              <v-row>
                 <v-col md="4"><strong>Bi:</strong></v-col>
                <v-col md="8"><span v-if="getRole !== 'ROLE_EST'">{{(usuario.length)?usuario[0].bilhete:''}}</span></v-col>
             </v-row>
              <v-row>
                 <v-col md="4"><strong>Gênero</strong></v-col>
                <v-col md="6"><span v-if="getRole !== 'ROLE_EST'">{{(usuario.length)?usuario[0].sexo:''}}</span><span v-if="getRole === 'ROLE_EST'">{{getIdPessoa}}</span></v-col>
             </v-row>
          </v-card-text>
          <br>
          <hr>
          <v-card-text>
             <v-row>
                 <v-col md="4"><strong>Nome do Pai:</strong></v-col>
                <v-col md="6"><span>{{(usuario.length)?usuario[0].nomepai:''}}</span><span v-if="getRole === 'ROLE_EST'">{{(usuario.length)?getIdPessoa:''}}</span></v-col>
             </v-row>
              <v-row>
                 <v-col md="4"><strong>Nome da Mãe:</strong></v-col>
                <v-col md="6"><span>{{(usuario.length)?usuario[0].nomemae:''}}</span><span v-if="getRole === 'ROLE_EST'">{{(usuario.length)?getIdPessoa:''}}</span></v-col>
             </v-row>
              <v-row>
                 <v-col md="4"><strong>Contacto:</strong></v-col>
                <v-col md="6"><span>{{(usuario.length)?usuario[0].contacto:''}}</span><span v-if="getRole === 'ROLE_EST'">{{(usuario.length)?getIdPessoa:''}}</span></v-col>
             </v-row>
             <v-row>
                 <v-col md="4"><strong>Status:</strong></v-col>
                <v-col md="8"><span><span>{{(usuario.length)?usuario[0].status_2:''}}</span></span><span v-if="getRole === 'ROLE_EST'">{{(usuario.length)?getIdPessoa:''}}</span></v-col>
             </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
            <br>
                      <div   :class="this.$store.state.classMessage" >{{this.$store.state.textMessage}}</div>

           <div style="background-color:#DEE2E2;text-align:center;color:blue;" >Edição de dados - Pessoais</div>
          <v-card-text>
             <v-row>
                 <v-col sm="4" md="4">Nome:</v-col>
                <v-col sm="8" md="8"><strong>{{loggedUserName}}</strong></v-col>
             </v-row>
             <v-row>
                 <v-col sm="3" md="4">Bilhete</v-col>
                <v-col sm="9" md="4">
                    <v-text-field
                     v-model="bilhete"
                       :rules="ruleBI"
                        v-mask="'#########-AA-###'"
                        label="Insira o número do bilhete"
                      ></v-text-field>
                </v-col>
             </v-row>
              <v-row>
                 <v-col sm="3" md="4">Gênero</v-col>
                <v-col sm="9" md="4">
                   <v-select
                      :items="sexo"
                      v-model="genero"
                      label="Selecione o Gênero"
                    ></v-select>
                </v-col>
             </v-row>
          </v-card-text>
          <br>
          <hr>
          <v-card-text>
             <v-row>
                 <v-col sm="3" md="4">Nome do Pai:</v-col>
                <v-col sm="9" md="5">
                     <v-text-field
                     v-model="nomepai"
                        label="Insira o nome do pai"
                      ></v-text-field>

                </v-col>
             </v-row>
              <v-row>
                 <v-col sm="3" md="4">Nome da Mãe:</v-col>
                  <v-col sm="9" md="5">
                     <v-text-field
                        v-model="nomemae"
                        label="Insira o nome da mãe"
                      ></v-text-field>

                </v-col>
             </v-row>
              <v-row>
                 <v-col sm="3" md="4">Contacto:</v-col>
                 <v-col sm="9" md="5">
                     <v-text-field
                        v-model="contacto"
                        label="Contacto"
                      ></v-text-field>

                </v-col>
             </v-row>
             <v-row>
                 <v-col sm="3" md="3"></v-col>
                <v-col sm="5" md="5"><v-btn color="primary" style="color:white;" @click="Actualizar()" :disabled="genero === '' || nomemae === '' || nomepai=== ''|| contacto=== ''">Actualizar</v-btn></v-col>
                <v-col sm="4" md="4">
                  <v-progress-circular
                      v-if="progresso"
                      indeterminate
                      color="green"
                  ></v-progress-circular>
                </v-col>
             </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>

  <!--======================================= MODAL==========Mudar Turma-Curso =======================================-->

      <v-dialog
      v-model="dialogo"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline"><v-icon color="blue">lock</v-icon>Mudança de Senha</v-card-title>

        <v-card-text>
           <v-row>

               <v-col cols="4">
                    <label> Nome de Usuário:</label>
               </v-col>
                <v-col cols="8">
                    <strong> {{(usuario.length)?usuario[0].username:''}}</strong>
               </v-col>

           </v-row>
           <v-row>

               <v-col cols="7">
                   <v-text-field
                   :rules="ruleTextRequire"
                   :type="'password'"
                   v-model="senha_actual"
                    label="Senha actual"
                  ></v-text-field>
               </v-col>
               <v-col cols="5">
                   <label style="color:red;" v-if="show_senha_errada">Senha incorrecta</label>
                   <label style="color:red;" v-if="error_senha_antiga_actual">A senha antiga não pode coincidir com a nova senha</label>
               </v-col>
           </v-row>
           <v-row>
              <v-col cols="7">
                <v-text-field
                :rules="[rules.required, rules.password_ , rules.password ]"
                v-model="senha_nova"
                :type="'password'"
                label="Nova Senha"
              ></v-text-field>
            </v-col>
           </v-row>
           <v-row>
              <v-col cols="7">
                <v-text-field
                v-model="senha_confirmar"
                label="Confirmar senha"
                :type="'password'"
              ></v-text-field>
            </v-col>
            <v-col cols="5">
                   <label style="color:red;" v-if="error_confirmar" >As senhas não correspondem</label>
               </v-col>
           </v-row>
           <v-row>
              <v-col cols="6"></v-col>
              <v-col cols="6">
                     <v-progress-circular
                      v-if="progresso"
                      indeterminate
                      color="green"
                  ></v-progress-circular>
               </v-col>
               <v-col cols="6" v-if="show_mensagem"><strong style="color:green;">Senha alterada com sucesso clique <v-btn text to="/">Aqui</v-btn> para sair</strong></v-col>
           </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="dialogo = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            :disabled="senha_actual === '' || senha_confirmar === '' || senha_nova === ''"
            @click="ContinuarMudarSenha()"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

<!-- ===================================== FIM DO MODAL ================================-->

  </v-card>
</div>
        </v-row>
      </v-container>
    </v-content>
 </v-app>
</div>
</template>
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
export default {
  directives: { mask },
  data: () => ({
    usuario: [],
    dialogo: false,
    senha_actual: '',
    bilhete: '',
    error_confirmar: false,
    show_senha_errada: false,
    error_senha_antiga_actual: false,
    progresso: false,
    senha_nova: '',
    nomemae: '',
    showpass: false,
    nomepai: '',
    genero: '',
    contacto: '',
    show_mensagem: false,
    usuario_encontrado: [],
    progresso: false,
    senha_confirmar: '',
    senha: false,
    rules: {
      required: value => !!value || 'Campo obrigatório.',
      /* sequential123: value => !value.includes('123') || 'A sequência 123 é invalida.',
      sequentialabc: value => !value.includes('abc') || 'A sequência abc é invalida.', */
      password_: value => value.length >= 8 || 'A password deve ter no minimo 8 caracteres',
      password: value => {
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/
        return (
          pattern.test(value) ||

            'A password deve ter ao menos uma letra maiúscula , minuscula e um número.'
        )
      }
    }
  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },

    getIdPessoa () {
      return ls.get('idPessoa')
    },

    getRole () {
      return ls.get('role')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Sub-Director Pedagógico'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.ObterUsuario()
  },
  methods: {

    logout () {
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    },

    async ObterUsuario () {
      try {
        this.usuario = await axios
          .get('/PerfilUsuario-dados')
          .then(res => res.data)
        console.log(this.usuario)

        this.isLoading = false
      } catch (error) {
      }
    },
    mudarSenha () {
      this.dialogo = true
    },

    async ContinuarMudarSenha () {
      // Verifica se a senha está correcta
      let dados_1 = {
        password: this.senha_actual
      }

      try {
        this.usuario_encontrado = await axios
          .post('/Verifica-senha/', dados_1)
          .then(res => res.data)
        console.log(this.usuario_encontrado)

        this.isLoading = false
      } catch (error) {
      }

      if (this.usuario_encontrado.length) {
        this.show_senha_errada = false

        if (this.senha_actual !== this.senha_nova) {
          this.error_senha_antiga_actual = false
          if (this.senha_nova === this.senha_confirmar) {
            this.progresso = true
            this.error_confirmar = false

            let valor = {

              password: this.senha_nova
            }

            /// Faz a alteraçaõ da senha
            try {
              let msg = await axios
                .post('/altera-senha/', valor)
                .then(res => res.data)
              this.ObterUsuario()
              this.progresso = false
              this.show_mensagem = true
              setTimeout(() => {

              }, 1000)
              this.Limpar()
            } catch (error) {
              this.progresso = false
            }
          } else { this.error_confirmar = true }
        } else { this.error_senha_antiga_actual = true }
      } else { this.show_senha_errada = true }
    },

    Limpar () {
      // eslint-disable-next-line no-unused-expressions
      this.senha_nova = ''
      this.senha_actual = ''
      this.senha_confirmar = ''
    },

    LimparUpdate (msg) {
      // eslint-disable-next-line no-unused-expressions
      this.bilhete = ''
      this.genero = ''
      this.contacto = ''
      this.nomemae = ''
      this.nomepai = ''
    },

    async Actualizar () {
      this.progresso = true
      const dados =
        {
          bilhete: this.bilhete,
          genero: this.genero,
          nomepai: this.nomepai,
          nomemae: this.nomemae,
          contacto: this.contacto
        }

      try {
        let msg = await axios
          .post('/actualizar-funcionario-activo', dados)
          .then(res => res.data)
        this.$store.dispatch('textMessage', { 'msg': 'Dados Pessoais actualizados com sucesso!', 'classMessage': 'msgSucess', 'timeout': 3000 })

        this.progresso = false
        this.LimparUpdate(msg)
        this.ObterUsuario()
      } catch (error) {
        this.progresso = false
      }
    }

  }

}

</script>
